import { FormControl, Validators } from '@angular/forms';
import { PartnersSelectionItem } from '../../../../../container-components/partners-selection/models';
import { EMAIL_PATTERN, PASSWORD_PATTERN, ListQueryParam, DEFAULT_PAGE_SIZE } from '../../../../../common/constants';
import { ApiAuthMethod, ApiConnectionFilterModelBase, ApiConnectionType } from '../constants/api-connection.constant';
import { mustNotBeBlankValidator } from '../../../../../common/utils';
import { FormBuilder } from '@angular/forms';
import { PartnerType } from '../../partner';

export class PartnersSelectionItemWithType extends PartnersSelectionItem {
  type: PartnerType;
  constructor(params?: PartnersSelectionItemWithType) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class ApiConnectionBrief {
  id: number | null = null;
  name: string | null = null;
  contactEmail: string | null = null;
  connectionType: ApiConnectionType = null;
  authMethod: ApiAuthMethod = null;
  partnerAssigned?: boolean;
}

export class ApiConnectionModel extends ApiConnectionBrief {
  applicationId: string | null = null;
  login: string | null = null;
  password: string | null = null;
  generatePassword = false;
  partners: PartnersSelectionItemWithType[] = [];
  constructor(params?: ApiConnectionModel) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class ApiConnectionResponseModel {
  id: number;
  name: string;
  contactEmail: string;
  connectionType: string;
  authMethod: ApiAuthMethod;
  login: string;
  partners: PartnersSelectionItemWithType[];
}

export class ApiConnectionForm {
  constructor(
    model: ApiConnectionModel,
    fb: FormBuilder = new FormBuilder(),
    public id: FormControl<number> = fb.control<number>(model.id, []),
    public name: FormControl<string> = fb.control<string>(model.name, [Validators.required, mustNotBeBlankValidator]),
    public contactEmail: FormControl<string> = fb.control<string>(model.contactEmail, [
      Validators.required,
      Validators.pattern(EMAIL_PATTERN),
    ]),
    public connectionType: FormControl<ApiConnectionType> = fb.control<ApiConnectionType>(model.connectionType, [
      Validators.required,
    ]),
    public authMethod: FormControl<ApiAuthMethod> = fb.control<ApiAuthMethod>(model.authMethod, [Validators.required]),
    public login: FormControl<string> = fb.control<string>(model.login, [Validators.required]),
    public password: FormControl<string> = fb.control<string>(model.password, [
      Validators.required,
      Validators.pattern(PASSWORD_PATTERN),
    ]),
    public applicationId: FormControl<string> = fb.control<string>(model.applicationId, [Validators.required]),
    public generatePassword: FormControl<boolean> = fb.control<boolean>(model.generatePassword, []),
    public partners: FormControl<PartnersSelectionItemWithType[]> = fb.control<PartnersSelectionItemWithType[]>(
      model.partners,
      model.partners.length ? [Validators.required] : [],
    ),
  ) {}
}

export class ApiConnectionListSearchCriteria extends ApiConnectionFilterModelBase {
  [ListQueryParam.Size] = DEFAULT_PAGE_SIZE;
  [ListQueryParam.Page] = 0;
  constructor(params?: ApiConnectionListSearchCriteria) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}
